import t from "../common/base-provider.js";
import r from "../managers/braze-instance.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import m from "../managers/subscription-manager.js";
import l from "../util/net.js";
import h from "../util/request-header-utils.js";
import { logger as E } from "../../shared-lib/index.js";
import {
  REQUEST_BACKOFF_MAX_SLEEP_MS_DEFAULT as u,
  REQUEST_BACKOFF_MIN_SLEEP_MS_DEFAULT as c,
  REQUEST_BACKOFF_SCALE_FACTOR_DEFAULT as d,
} from "../common/constants.js";
import { randomInclusive as a } from "../util/math.js";
import {
  MAX_RETRIES as ii,
  buildSseUrl as ti,
} from "./dust-connection-core.js";
import {
  DustWorkerBridge as si,
  isSharedWorkerSupported as ei,
} from "./dust-worker-bridge.js";
export default class tr extends t {
  constructor(i, t, s, e, n = !0) {
    super(),
      (this.j = i),
      (this.B = t),
      (this.h = s),
      (this.j = i),
      (this.B = t),
      (this.h = s),
      (this.mite = null),
      (this.ki = null),
      (this.yi = null),
      (this.$i = null),
      (this.Ri = e || null),
      (this.Mi = null),
      (this.xi = null),
      (this.D = null),
      (this.ji = 0),
      (this.Wi = ii),
      (this.Fi = null),
      (this.Ui = null),
      (this.zi = !0),
      (this.Bi = null),
      (this.Gi = null),
      (this.Pi = null),
      (this.qi = null),
      (this.Hi = !1),
      (this.Ji = new Map()),
      (this.Li = null),
      (this.Oi = null),
      (this.Ki = null),
      (this.Qi = this.Vi(n)),
      (this.Xi = !1),
      (this.Yi = 0),
      this.Zi();
  }
  Vi(i) {
    return i
      ? ei()
        ? "sharedworker"
        : (E.info(
            "SharedWorker not supported, using direct EventSource (multi-tab will gracefully degrade)",
          ),
          "direct")
      : (E.info("Shared connection disabled, using direct EventSource"),
        "direct");
  }
  _i() {
    this.Ki = new si({
      we: (i) => {
        this.Se(i);
      },
      ke: () => {
        this.ye();
      },
      Re: () => {},
      Me: (i) => {
        E.error(`Real-time messaging SharedWorker error: ${i}`);
      },
    });
    this.Ki.initialize() ||
      (E.info(
        "SharedWorker initialization failed, falling back to direct EventSource",
      ),
      (this.Qi = "direct"),
      (this.Ki = null));
  }
  ye() {
    (this.ji = 0),
      (this.Bi = null),
      (this.zi = !0),
      (this.Xi = !1),
      (this.Yi = 0);
  }
  Se(i) {
    if (!i.type)
      return void E.warn(
        `Received real-time message without type: ${JSON.stringify(i)}`,
      );
    const t = "sharedworker" === this.Qi ? "SharedWorker" : "Direct";
    E.info(`Received real-time message of type '${i.type}' via ${t}`);
    const s = this.Ji.get(i.type);
    if (s && s.De() > 0)
      try {
        s.L(i);
      } catch (t) {
        E.error(
          `Error invoking subscription for message type '${i.type}': ${t}`,
        );
      }
    else E.info(`No subscribers for real-time message type '${i.type}'`);
  }
  We() {
    return "sharedworker" === this.Qi;
  }
  Fe() {
    return this.Qi;
  }
  Zi() {
    if (this.B) {
      const i = this.B.dt(s.ft.Ue),
        t = this.B.dt(s.ft.Ne),
        e = this.B.dt(s.ft.Te),
        n = this.B.dt(s.ft.ze);
      i && t
        ? ((this.mite = i),
          (this.ki = t),
          (this.yi = e),
          (this.$i = n),
          E.info("Restored real-time messaging configuration from storage"))
        : (i || t) &&
          (E.warn(
            "Incomplete real-time messaging configuration in storage, clearing",
          ),
          this.Ae());
    }
  }
  Hr() {
    this.Li ||
      this.Oi ||
      ((this.Li = this.Be("ddr", (i) => {
        if (!i.body || "number" != typeof i.body.Ge) return;
        const t = Math.random() * i.body.Ge * 0.3,
          s = Math.round(i.body.Ge + t),
          e = i.body.e ? ` (${i.body.e})` : "";
        E.info(`Admin requested disconnect${e}, reconnecting in ${s}ms`),
          this.Pe(),
          setTimeout(() => this.qe(), s);
      })),
      (this.Oi = this.Be("ttl", (i) => {
        if (!i.body || "number" != typeof i.body.He) return;
        const t = i.body.He;
        E.info(`Time to live set to ${t}ms, will reconnect when expired`),
          "sharedworker" !== this.Qi &&
            ("string" == typeof i.body.Je && (this.Mi = i.body.Je),
            null !== this.Ui && window.clearTimeout(this.Ui),
            (this.Ui = window.setTimeout(() => {
              (this.Ui = null),
                E.info("Time to live expired, performing gapless reconnection"),
                this.Le();
            }, t)));
      })));
  }
  Oe() {
    this.Gi ||
      this.Pi ||
      ((this.qi = () => {
        (this.Hi = !0), (this.zi = !1);
      }),
      window.addEventListener("beforeunload", this.qi),
      (this.Gi = () => {
        var i;
        this.Hi = !0;
        (this.xi ||
          (null === (i = this.Ki) || void 0 === i ? void 0 : i.Ie())) &&
          (E.info("Page unloading, closing real-time connection gracefully"),
          (this.zi = !1),
          this.Pe());
      }),
      window.addEventListener("pagehide", this.Gi),
      (this.Pi = (i) => {
        var t;
        const s =
          this.xi || (null === (t = this.Ki) || void 0 === t ? void 0 : t.Ie());
        i.persisted &&
          this.Ke() &&
          !s &&
          (E.info("Page restored from bfcache, reconnecting"),
          (this.Hi = !1),
          this.ye(),
          this.qe());
      }),
      window.addEventListener("pageshow", this.Pi));
  }
  St() {
    return this.D;
  }
  wt(i) {
    this.D = i;
  }
  Be(i, t) {
    if ("function" != typeof t) return null;
    let s = this.Ji.get(i);
    return s || ((s = new m()), this.Ji.set(i, s), r.q(s)), s.Rt(t);
  }
  Qe(i, t) {
    const s = this.Ji.get(i);
    s && s.removeSubscription(t);
  }
  Ke() {
    return Boolean(this.mite && this.ki);
  }
  Ve() {
    if (!this.$i) return !1;
    return Math.floor(new Date().valueOf() / 1e3) >= this.$i;
  }
  Ae() {
    (this.mite = null),
      (this.ki = null),
      (this.yi = null),
      (this.$i = null),
      (this.Mi = null),
      this.B &&
        (this.B.zt(s.ft.Ue),
        this.B.zt(s.ft.Ne),
        this.B.zt(s.ft.Te),
        this.B.zt(s.ft.ze));
  }
  Xe(i, t) {
    const e = () => {
        "function" == typeof t && t();
      },
      n = this.j,
      r = this.B;
    if (!n || !r)
      return (
        E.error("NetworkManager or StorageManager not available"), void e()
      );
    if (!this.h || !this.h.Ye())
      return (
        E.info("Real-time messaging is not enabled, skipping refresh"), void e()
      );
    this.Ke()
      ? E.info("Refreshing real-time messaging configuration")
      : E.info("Fetching initial real-time messaging configuration");
    const o = n.$({}, !0),
      a = n.A(o, h.H.Ze, !1),
      c = new Date().valueOf();
    h.K(r, h.H.Ze, c),
      l.O({
        url: `${n.V()}/dust/config`,
        headers: a,
        data: o,
        W: (t) => {
          if (!n.Y(o, t, a))
            return (
              E.error(
                "Failed to validate server response for real-time messaging configuration",
              ),
              void e()
            );
          n.Z(),
            t.mite && t.host
              ? ((this.mite = t.mite),
                (this.ki = t.host),
                (this.yi = t.auth || null),
                (this.$i = t.expiration || null),
                E.info(
                  "Received real-time messaging configuration from server",
                ),
                r.bt(s.ft.Ue, t.mite),
                r.bt(s.ft.Ne, t.host),
                t.auth ? r.bt(s.ft.Te, t.auth) : r.zt(s.ft.Te),
                t.expiration ? r.bt(s.ft.ze, t.expiration) : r.zt(s.ft.ze),
                this.qe(),
                "function" == typeof i && i())
              : (E.info(
                  "Real-time messaging configuration not available - this SDK version may not be supported",
                ),
                this.Ae(),
                e());
        },
        error: (i) => {
          n._(i, "retrieving DUST config"), e();
        },
      });
  }
  qe() {
    if (!this.h || !this.h.Ye()) return;
    if (!this.Ke())
      return void E.error(
        "Cannot start real-time subscription without configuration",
      );
    if (this.Ve())
      return (
        E.info(
          "Real-time messaging auth token has expired, refreshing configuration",
        ),
        void this.Xe(
          () => {
            this.qe();
          },
          () => {
            E.error(
              "Failed to refresh expired real-time messaging configuration",
            );
          },
        )
      );
    const i = this.mite,
      t = this.Ri || this.ki;
    if (i && t)
      switch (this.Qi) {
        case "sharedworker":
          this._e(i, t);
          break;
        case "direct":
          this.xi &&
            (E.info(
              "Real-time connection already exists, closing before starting new subscription",
            ),
            this.Pe()),
            this.sn();
      }
  }
  en() {
    const i = this.mite,
      t = this.Ri || this.ki;
    return i && t
      ? ti(t, i, this.ji, this.yi || void 0, this.Mi || void 0)
      : null;
  }
  _e(i, t) {
    var s, e, n;
    if ((this.Ki || this._i(), !this.Ki))
      return (
        E.info(
          "SharedWorker initialization failed, falling back to direct EventSource",
        ),
        (this.Qi = "direct"),
        void this.on()
      );
    this.Ri && E.info(`Using custom real-time messaging host: ${this.Ri}`),
      E.info("Starting real-time subscription via SharedWorker");
    const r = (null === (s = this.h) || void 0 === s ? void 0 : s.st()) || c,
      o = (null === (e = this.h) || void 0 === e ? void 0 : e.nt()) || u,
      h = (null === (n = this.h) || void 0 === n ? void 0 : n.it()) || d;
    this.Ki.connect({
      mite: i,
      ki: t,
      auth: this.yi || void 0,
      hn: { an: r, ln: o, cn: h },
    });
  }
  on() {
    this.xi &&
      (E.info(
        "Real-time connection already exists, closing before starting new subscription",
      ),
      this.un()),
      this.sn();
  }
  sn(i) {
    const t = this.en();
    if (t) {
      this.Ri && E.info(`Using custom real-time messaging host: ${this.Ri}`);
      try {
        const s = new EventSource(t);
        (s.onopen = () => {
          i
            ? (E.info(
                "Gapless reconnection: new connection established, closing old connection",
              ),
              i.close())
            : E.info("Real-time messaging connection established"),
            (this.xi = s),
            (this.ji = 0),
            (this.Bi = null),
            (this.zi = !0),
            (this.Xi = !0);
        }),
          s.addEventListener("msg", (i) => {
            this.dn(i.data);
          }),
          (s.onerror = () => {
            const t = s.readyState;
            return (
              this.Hi ||
                (0 === t
                  ? E.info("Real-time messaging failed to connect")
                  : E.info("Real-time messaging connection lost")),
              i && this.xi !== s
                ? (E.info(
                    "Gapless reconnection failed, keeping old connection",
                  ),
                  s.close(),
                  void (this.zi && this.ji < this.Wi && this.gn()))
                : (this.un(),
                  this.Xi && (this.Yi++, this.Yi > 1)
                    ? (E.info(
                        "Real-time messaging connection lost twice after successful connect (likely multi-tab conflict), yielding to other tab",
                      ),
                      void (this.zi = !1))
                    : void (this.zi && this.ji < this.Wi
                        ? this.gn()
                        : (this.ji >= this.Wi &&
                            E.error(
                              `Max retry attempts (${this.Wi}) reached for real-time messaging, giving up for current session`,
                            ),
                          (this.zi = !1))))
            );
          });
      } catch (i) {
        E.error(
          `Failed to create real-time messaging connection: ${
            i instanceof Error ? i.message : String(i)
          }`,
        );
      }
    }
  }
  gn() {
    var i, t, s;
    this.ji++;
    const e = (null === (i = this.h) || void 0 === i ? void 0 : i.st()) || c,
      n = (null === (t = this.h) || void 0 === t ? void 0 : t.it()) || d,
      r = (null === (s = this.h) || void 0 === s ? void 0 : s.nt()) || u;
    let o = this.Bi;
    (null == o || o < e) && (o = e);
    const h = Math.min(r, a(e, o * n));
    (this.Bi = h),
      E.info(
        `Retrying real-time messaging connection in ${h}ms (attempt ${this.ji}/${this.Wi})`,
      ),
      (this.Fi = window.setTimeout(() => {
        (this.Fi = null), this.qe();
      }, h));
  }
  Le() {
    if (this.Ke()) {
      if (this.Ve())
        return (
          E.info(
            "Auth token expired during gapless reconnection, falling back to regular reconnection",
          ),
          this.Pe(),
          void this.qe()
        );
      null !== this.Ui && (window.clearTimeout(this.Ui), (this.Ui = null)),
        this.sn(this.xi || void 0);
    } else E.error("Cannot perform gapless reconnection without configuration");
  }
  Pe() {
    var i;
    switch (this.Qi) {
      case "sharedworker":
        null === (i = this.Ki) || void 0 === i || i.disconnect();
        break;
      case "direct":
        this.un();
    }
  }
  un() {
    null !== this.Fi && (window.clearTimeout(this.Fi), (this.Fi = null)),
      null !== this.Ui && (window.clearTimeout(this.Ui), (this.Ui = null)),
      this.xi &&
        (this.xi.close(),
        (this.xi = null),
        E.info("Real-time messaging connection closed"));
  }
  dn(i) {
    try {
      const t = JSON.parse(i);
      this.Se(t);
    } catch (i) {
      E.warn(
        `Failed to parse real-time message: ${
          i instanceof Error ? i.message : String(i)
        }`,
      );
    }
  }
  changeUser(i = !1) {
    this.Pe(),
      i ||
        (this.Ke() &&
          E.info(
            "Clearing cached real-time messaging configuration for user change",
          ),
        this.Ae()),
      this.ye();
  }
  clearData(i = !1) {
    (this.zi = !1),
      this.Pe(),
      i &&
        (this.Ke() &&
          E.info(
            "Clearing cached real-time messaging configuration (wipeData)",
          ),
        this.Ae()),
      this.ye();
  }
  destroy() {
    (this.zi = !1),
      this.Pe(),
      this.Ae(),
      this.Ki && (this.Ki.destroy(), (this.Ki = null)),
      this.Li && (this.Qe("ddr", this.Li), (this.Li = null)),
      this.Oi && (this.Qe("ttl", this.Oi), (this.Oi = null)),
      this.qi &&
        (window.removeEventListener("beforeunload", this.qi), (this.qi = null)),
      this.Gi &&
        (window.removeEventListener("pagehide", this.Gi), (this.Gi = null)),
      this.Pi &&
        (window.removeEventListener("pageshow", this.Pi), (this.Pi = null)),
      this.D && (r.removeSubscription(this.D), (this.D = null));
  }
}
